import axiosClient from "../../../shared/lib/http/axiosClient";
import { DesignSettings, DesignSettingsSchema } from "../../../models/design-settings";
import { z } from "zod";

const DesignSettingsListSchema = z.array(DesignSettingsSchema);

export type DesignSettingsSortField =
  | 'id'
  | 'user_id'
  | 'highlight_color'
  | 'main_color'
  | 'input_text_color'
  | 'input_title_text_color'
  | 'input_border_color'
  | 'background_color'
  | 'section_color'
  | 'header_color'
  | 'created_at'
  | 'updated_at'
  ;

export type DesignSettingsSort = DesignSettingsSortField | `-${DesignSettingsSortField}`;

/**
 * - sort - which fields to sort by, and in which direction. for example: ["id"] or ["-created_at"].
 * - filter - fields to filter by (Spatie `filter[...]` query params).
 */
interface IndexParams {
  sort?: DesignSettingsSort[],
  filter?: {
    user_id?: number,
  },
}

function getParamString(params: IndexParams) {
  const { sort, filter } = params;

  return {
    params: {
      use_cache: 1,
      ...(sort?.length && { sort: sort.join(',') }),
      ...(filter?.user_id !== undefined && { 'filter[user_id]': filter.user_id }),
    },
  };
}

/**
 * Fetches design settings for the current business.
 * @param params IndexParams object containing sort and filter parameters.
 */
export const getDesignSettings = async (
  params: IndexParams = {},
  signal?: AbortSignal,
): Promise<DesignSettings[]> => {
  const response = await axiosClient.get(
    `/api/design-settings`,
    { ...getParamString(params), signal },
  );

  return DesignSettingsListSchema.parse(response.data);
};

export const saveDesignSettings = async (designSettingsId: number, designSettingsToSave: DesignSettings): Promise<DesignSettings> => {
  
  const response = await axiosClient.patch(
    `/api/design-settings/${designSettingsId}`,
    designSettingsToSave
  );

  return response.data;
};
